module.exports = __webpack_public_path__ + "img/logo_black.87a3213f.svg";